import { luscinia } from './luscinia';

luscinia.redirectToEmailClient = (receiverAddress: string, subject: string) => {
    const mailtoLink = `mailto:${receiverAddress}?subject=${subject}`;
    window.location.href = mailtoLink;
};

luscinia.updateMailToMailAddress = (receiverAddress: string, elementSelectorToUpdate: string) => {
    let element = document.querySelector(elementSelectorToUpdate);
    let currentValue = element.getAttribute('onclick');
    element.setAttribute('onclick', reconstructFunction(currentValue, receiverAddress));
};

luscinia.downloadFileAndRedirectToEmailClient = (receiverAddress: string, subject: string, fileUrl: string, fileName: string) => {
    downloadPdf(fileUrl, fileName);
    luscinia.redirectToEmailClient(receiverAddress, subject);
};

luscinia.sendPasswordResetMail = (emailAddress: string): void => {
    $.ajax({
        type: 'GET',
        url: "/resetpasswordsend/" + emailAddress,
        success: function (data) {
            luscinia.showNotification('Success', 'Password reset mail sent', 'success');
        }, error: function (jqXHR, textStatus, errorThrown) {
            luscinia.showNotification('Error', 'Password reset mail could not be sent', 'danger');
        }
    });
}
luscinia.sendSecretKeyResetMail = (emailAddress: string): void => {
    $.ajax({
        type: 'GET',
        url: "/resetsecretkeysend/" + emailAddress,
        success: function (data) {
            luscinia.showNotification('Success', 'Secret key reset mail sent', 'success');
        }, error: function (jqXHR, textStatus, errorThrown) {
            luscinia.showNotification('Error', 'Secret key reset mail could not be sent', 'danger');
        }
    });        
}

function downloadPdf(url, filename) {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

function reconstructFunction(func: string, receiverAddress: string): string {
    func = replaceParameter(func, `'${receiverAddress}'`, 0);
    var reportButton = document.getElementById('reportButton');
    func = replaceParameter(func, `'${reportButton.getAttribute('href')}'`, 2);
    return func;
}

function replaceParameter(oldFuncString: string, newValue: string, argIndex: number) {
    const match = oldFuncString.match(/^([\w.]+)\(([^)]+)\)$/);
    if (!match) {
        throw new Error('Invalid function string');
    }

    const funcName = match[1];
    const args = match[2].split(',');

    if (argIndex < 0 || argIndex >= args.length) {
        throw new Error('Argument index out of range');
    }

    args[argIndex] = newValue;

    const newFuncString = `${funcName}(${args.join(', ')})`;

    return newFuncString;
}